<template>
  <section>
    <div class="space-y-4" v-if="data && data.length">
      <div class="w-full" v-for="d in data" :key="d.id">
        <div class="flex items-center w-full">
          <div class="md:flex flex-col items-center py-4">
            <Avatar
              :src="baseUrlSrc(d.thumbnail_url)"
              :classStr="'h-12 w-12'"
            />
            <p
              class="md:w-16 w-16 text-gray-dark text-xs font-medium py-2 capitalize"
            >
              {{ d.name }}
            </p>
          </div>
          <div class="md:ml-10 ml-2 w-full">
            <div class="flex items-center justify-between border-b-2">
              <p v-if="d && d.expectation_id" class="text-gray-dark text-md font-medium py-2">
                This class {{ getExpectationValue(d.expectation_id) }} my
                expectations!
              </p>
              <p class="font-semibold capitalize" v-else>{{ d.title }}</p>
              <div class="relative inline-block text-left">
                <div>
                  <button
                    type="button"
                    class="bg-gray-50 rounded-full flex items-center text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-100 focus:ring-indigo-500"
                    @click="toggleDropdown(d.id)"
                  >
                    <span class="sr-only">Open options</span>
                    <!-- Heroicon name: solid/dots-vertical -->
                    <svg
                      class="h-5 w-5"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"
                      />
                    </svg>
                  </button>
                </div>
                <div
                  class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1  ring-gray-300 ring-opacity-5 focus:outline-none"
                  v-if="dropdownPopoverShow[d.id]"
                >
                  <div class="py-1" role="none" v-if="d.edit">
                    <a
                      href="javascript:void(0)"
                      class="bg-gray-100 text-gray-900 block px-4 py-2 text-sm"
                      @click="handleReviewEdit(d.id)"
                    >
                      Edit
                    </a>
                    <a
                      href="javascript:void(0)"
                      class="text-gray-700 block px-4 py-2 text-sm"
                      @click="handleReviewDel(d.id)"
                    >
                      Delete
                    </a>
                  </div>
                  <ReportDropdown
                    v-model="dropdownPopoverShow[d.id]"
                    :cat_item_id="d.id"
                    :category_id="REVIEWS"
                    v-else
                  />
                </div>
              </div>
            </div>
            <p v-if="d && d.description" class="text-gray-dark text-xs py-4">
              {{ d.description }}
            </p>
            <p class="pt-2" v-else>
              {{ d.body }}
            </p>
            <span
              class="text-gray-darkest text-xs float-right"
              v-if="d.created_at"
            >
              Posted <span>{{ handleCreatedAt(d.created_at) }}</span>
            </span>
          </div>
        </div>
      </div>
    </div>
    <p class="text-gray-dark text-xs" v-else>No Reviews found.</p>
  </section>
</template>

<script>
import ReportDropdown from "@/components/report/ReportDropdown";
import { Avatar } from "@/components/t-components";
import ClickOutside from "vue-click-outside";
import { mapActions } from "vuex";

export default {
  name: "SessionReviewList",
  components: {
    Avatar,
    ReportDropdown,
  },
  props: {
    data: {
      type: [Array, Object],
    },
    showEditDelSessionDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      dropdownPopoverShow: [],
      REVIEWS: 2,
    };
  },
  methods: {
    ...mapActions(["deleteSessionReview"]),

    toggleDropdown(id) {
      var obj = {};
      obj[id] = !this.dropdownPopoverShow[id];
      this.dropdownPopoverShow = obj;
    },

    handleOutside() {
      this.dropdownPopoverShow = false;
    },

    handleReviewDel(id) {
      this.$emit("del-rating", id);
      this.toggleDropdown();
    },

    handleReviewEdit(id) {
      this.$emit("edit-rating", id);
      this.toggleDropdown();
    },
  },
  directives: {
    ClickOutside,
  },
};
</script>